/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Day_Based_PriceInputs */

const en_admin_resource_form_day_based_price = /** @type {(inputs: Admin_Resource_Form_Day_Based_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Day-based price:`)
};

const de_admin_resource_form_day_based_price = /** @type {(inputs: Admin_Resource_Form_Day_Based_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tagespreis:`)
};

const es_admin_resource_form_day_based_price = /** @type {(inputs: Admin_Resource_Form_Day_Based_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio por días:`)
};

const fr_admin_resource_form_day_based_price = /** @type {(inputs: Admin_Resource_Form_Day_Based_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarif journalier :`)
};

const nl_admin_resource_form_day_based_price = /** @type {(inputs: Admin_Resource_Form_Day_Based_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dagtarief:`)
};

/** @type {(inputs: Admin_Resource_Form_Day_Based_PriceInputs) => LocalizedString} */
const it_admin_resource_form_day_based_price = en_admin_resource_form_day_based_price;

/** @type {(inputs: Admin_Resource_Form_Day_Based_PriceInputs) => LocalizedString} */
const pt_br2_admin_resource_form_day_based_price = en_admin_resource_form_day_based_price;

/** @type {(inputs: Admin_Resource_Form_Day_Based_PriceInputs) => LocalizedString} */
const pl_admin_resource_form_day_based_price = en_admin_resource_form_day_based_price;

/** @type {(inputs: Admin_Resource_Form_Day_Based_PriceInputs) => LocalizedString} */
const hu_admin_resource_form_day_based_price = en_admin_resource_form_day_based_price;

/** @type {(inputs: Admin_Resource_Form_Day_Based_PriceInputs) => LocalizedString} */
const ro_admin_resource_form_day_based_price = en_admin_resource_form_day_based_price;

/**
* | output |
* | --- |
* | "Day-based price:" |
*
* @param {Admin_Resource_Form_Day_Based_PriceInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_day_based_price = /** @type {((inputs?: Admin_Resource_Form_Day_Based_PriceInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Day_Based_PriceInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_day_based_price(inputs)
	if (locale === "de") return de_admin_resource_form_day_based_price(inputs)
	if (locale === "es") return es_admin_resource_form_day_based_price(inputs)
	if (locale === "fr") return fr_admin_resource_form_day_based_price(inputs)
	if (locale === "nl") return nl_admin_resource_form_day_based_price(inputs)
	if (locale === "it") return it_admin_resource_form_day_based_price(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_day_based_price(inputs)
	if (locale === "pl") return pl_admin_resource_form_day_based_price(inputs)
	if (locale === "hu") return hu_admin_resource_form_day_based_price(inputs)
	return ro_admin_resource_form_day_based_price(inputs)
});
export { admin_resource_form_day_based_price as "admin.resource_form.day_based_price" }